/**
 * API call service
 */

class AuthService {
    // @ngInject
    constructor(CONSTANTS, $state) {
        //this.localStorageService = localStorageService;
        //this.q = $q;
        this.CONSTANTS = CONSTANTS;
        this.state = $state;
    }

    callAPI(endpoint, method, args, callback) {
        try {
            var url = this.CONSTANTS.NODE_URL + endpoint;
            //var url = endpoint;
            console.log(url)
            var xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = function() {
                if (this.readyState == 4 && this.status == 200) {
                    let resultObj = {
                        "result": undefined,
                        "error": undefined
                    };
                    try {
                        resultObj.result = JSON.parse(xhttp.responseText);
                        callback(resultObj);
                    } catch (error) {
                        resultObj.error = "Bad Request - End Point is invalid";
                        callback(resultObj);
                    }
                } else {
                    if (this.readyState == 4) {
                        let resultObj = {
                            "result": undefined,
                            "error": undefined
                        };
                        resultObj.error = JSON.parse(xhttp.responseText);
                        callback(resultObj);
                    }
                }
            };
            xhttp.open(method, url, true);
            xhttp.withCredentials = true;
            xhttp.setRequestHeader("Content-type", "application/json");
            xhttp.setRequestHeader("x-auth-token", "tq355lY3MJyd8Uj2ySzm");
            xhttp.setRequestHeader("x-auth-userid", "44B7TvzRTZkpdxs9u");
            xhttp.onerror = function(e) {
                let resultObj = {
                    "result": undefined,
                    "error": undefined
                };
                resultObj.error = "Bad Request - Server is Down";
                callback(resultObj);
            };
            if (args != undefined) {
                xhttp.send(JSON.stringify(args));
            } else {
                xhttp.send();
            }
        } catch (ex) {
            console.log(ex);
        }
    }
}

export default AuthService;


// WEBPACK FOOTER //
// ./src/app/login/services/authService.js